import GeoMap from '@transferz/fe-component-library/geo-map';
import React, { useEffect, useRef, useState } from 'react';

export const GeoPoint: any = (props: any) => {
  const {
    position,
    travellerPosition,
    center,
    zoom = 12,
    draggable = true,
    googleApiKey,
  } = props;
  const [positionId, setPositionId] = useState<any>();
  const [userPosition, setUserPosition] = useState<any>();
  const markerRef = useRef(null) as any;
  const userPositionIconRef = useRef(null) as any;
  const travellerPositionIconRef = useRef(null) as any;
  const mapRef = useRef(null) as any;
  const mapsRef = useRef(null) as any;

  const haversineDistance = (pos1: any, pos2: any) => {
    // Radius of the Earth in km
    const R = 6371.1;
    // Convert degrees to radians
    const rlat1 = pos1.lat * (Math.PI / 180);
    // Convert degrees to radians
    const rlat2 = pos2.lat * (Math.PI / 180);
    // Radian difference (latitudes)
    const difflat = rlat2 - rlat1;
    // Radian difference (longitudes)
    const difflon = (pos2.lng - pos1.lng) * (Math.PI / 180);

    // eslint-disable-next-line no-mixed-operators
    return 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) +
      Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
  };

  const addUserIcon = ({ map }: any, pos: any) => {
    if (userPositionIconRef.current) {
      userPositionIconRef.current.setMap(null);
    }
    userPositionIconRef.current = new google.maps.Marker({
      position: pos,
      icon: {
        anchor: new google.maps.Point(16, 16),
        // eslint-disable-next-line no-multi-str
        url: 'data:image/svg+xml;utf-8, \
        <svg width="48" height="48" viewBox="0 0 40 40"  xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="8" fill="none" stroke="rgb(0, 131, 168)" stroke-width="2"><animate attributeName="r" begin="0s" dur="1.5s" from="8" repeatCount="indefinite" to="20"/><animate attributeName="opacity" begin="0s" dur="1.5s" from="1" repeatCount="indefinite" to="0"/></circle><circle cx="20" cy="20" r="10" fill="rgb(0, 131, 168)"/></svg>',
      },
      map,
    });
  };

  const addMarker = ({ map, maps }: any, markerPos: any) => {
    if (markerRef.current) {
      markerRef.current.setMap(null);
    }
    navigator.geolocation.getCurrentPosition((pos) => {
      const userPos = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      addUserIcon({ map }, userPos);
      setUserPosition(userPos);
      if (haversineDistance(position, userPos) < 5) {
        const bounds = new maps.LatLngBounds();
        bounds.extend(position);
        bounds.extend({ lat: userPosition.coords.latitude, lng: userPosition.coords.longitude });
        map.fitBounds(bounds);
      }
    });
    const id = navigator.geolocation.watchPosition((pos) => {
      const userPos = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      addUserIcon({ map }, { lat: pos.coords.latitude, lng: pos.coords.longitude });
      setUserPosition(userPos);
    });
    setPositionId(id);
    if (markerRef) {
      markerRef.current = new maps.Marker({
        markerPos,
        map,
        draggable,
      });
    }
  };

  const handleApiLoaded = ({ map, maps }: any) => {
    mapRef.current = map;
    mapsRef.current = maps;
    if (position?.lat && position?.lng) {
      addMarker({ map, maps }, position);
    }
  };

  const addTravellerIcon = ({ map }: any) => {
    if (travellerPositionIconRef.current) {
      travellerPositionIconRef.current.setMap(null);
    }
    const svg =
      `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="1080" height="1080" viewBox="0 0 1080 1080" xml:space="preserve">
<desc>Created with Fabric.js 5.2.4</desc>
<defs>
</defs>
<g transform="matrix(1 0 0 1 540 540)" id="5daa2645-e41b-4e2a-9173-b490c7c41aea"  >
<rect style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1; visibility: hidden;" vector-effect="non-scaling-stroke"  x="-540" y="-540" rx="0" ry="0" width="1080" height="1080" />
</g>
<g transform="matrix(1 0 0 1 540 540)" id="2237d48f-7bfc-4fde-9065-36cfaa789eae"  >
</g>
<g transform="matrix(22.5 0 0 22.5 516 540)"  >
<circle style="stroke: rgb(146,0,169); stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: none; fill-rule: nonzero; opacity: 1;" vector-effect="non-scaling-stroke"  cx="0" cy="0" r="18" ><animate attributeName="r" begin="0s" dur="1.5s" from="8" repeatCount="indefinite" to="23"/><animate attributeName="opacity" begin="0s" dur="1.5s" from="1" repeatCount="indefinite" to="0"/></circle>
</g>
<g transform="matrix(22.5 0 0 22.5 516 540)"  >
<rect style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(146,0,169); fill-rule: nonzero; opacity: 1;" vector-effect="non-scaling-stroke"  x="-15" y="-15" rx="15" ry="15" width="30" height="30" />
</g>
<g transform="matrix(22.5 0 0 22.5 509.9 540)"  >
<path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: evenodd; opacity: 1;" vector-effect="non-scaling-stroke"  transform=" translate(-9, -6.75)" d="M 12 6.75 C 12 8.40685 10.6569 9.75 9 9.75 C 7.34315 9.75 6 8.40685 6 6.75 C 6 5.09315 7.34315 3.75 9 3.75 C 10.6569 3.75 12 5.09315 12 6.75 Z M 10.5 6.75 C 10.5 7.57843 9.82843 8.25 9 8.25 C 8.17157 8.25 7.5 7.57843 7.5 6.75 C 7.5 5.92157 8.17157 5.25 9 5.25 C 9.82843 5.25 10.5 5.92157 10.5 6.75 Z" stroke-linecap="round" />
</g>
<g transform="matrix(26.33 0 0 26.33 512.91 540)"  >
<path style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: evenodd; opacity: 1;" vector-effect="non-scaling-stroke"  transform=" translate(-9, -9)" d="M 9 0.75 C 4.44365 0.75 0.75 4.44365 0.75 9 C 0.75 13.5563 4.44365 17.25 9 17.25 C 13.5563 17.25 17.25 13.5563 17.25 9 C 17.25 4.44365 13.5563 0.75 9 0.75 Z M 2.25 9 C 2.25 10.5677 2.78441 12.0105 3.68099 13.1563 C 4.91434 11.5417 6.8597 10.5 9.04836 10.5 C 11.2086 10.5 13.1319 11.5148 14.3674 13.0937 C 15.2348 11.9582 15.75 10.5393 15.75 9 C 15.75 5.27208 12.7279 2.25 9 2.25 C 5.27208 2.25 2.25 5.27208 2.25 9 Z M 9 15.75 C 7.38733 15.75 5.90674 15.1845 4.74575 14.2409 C 5.69514 12.8859 7.26829 12 9.04836 12 C 10.8063 12 12.3625 12.8641 13.3153 14.1906 C 12.1454 15.1643 10.6411 15.75 9 15.75 Z" stroke-linecap="round" />
</g>
</svg>
`;

    travellerPositionIconRef.current = new google.maps.Marker({
      position: travellerPosition.position,
      optimized: false,
      icon: {
        anchor: new google.maps.Point(16, 16),
        scaledSize: new google.maps.Size(45, 45),
        url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(svg),
      },
      map,
    });
  };

  useEffect(() => {
    if (travellerPosition && mapRef.current) {
      addTravellerIcon({ map: mapRef.current });
    }
  }, [travellerPosition]);

  useEffect(() => () => {
    navigator.geolocation.clearWatch(positionId);
  }, [positionId]);

  return (
    <div>
      <GeoMap
        className="geo-map"
        position={travellerPosition}
        handleApiLoaded={handleApiLoaded}
        center={center}
        zoom={zoom}
        width="auto"
        height="375px"
        apiKey={googleApiKey}
        options={{
          disableDefaultUI: false,
          draggable: true,
        }}
      />
    </div>
  );
};
